import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const emailsUrl = "/api/v2/email/linecard";

export interface DownloadLineCardModel extends BaseModel {
    name: string;
    email: string;
    companyName: string;
    emailTo: string;
    businessDivisions: string[];
}

export interface DownloadLineCardApiParameter extends ApiParameter {
    downloadLineCardModel: DownloadLineCardModel;
}

export function downloadLineCardModelService(parameter: DownloadLineCardApiParameter) {
    return post<DownloadLineCardModel>(`${emailsUrl}`, parameter.downloadLineCardModel);
}
